exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2JG7A_8dSANVgfbW3HqMHD{width:100%;overflow:hidden;position:relative}._2JG7A_8dSANVgfbW3HqMHD img{left:0;position:absolute;width:100%}\n", ""]);

// Exports
exports.locals = {
	"FullWidthImageViewer": "_2JG7A_8dSANVgfbW3HqMHD"
};